import { SITE } from '@/app/constants';
import type { CreationInfo, TaskInfo } from '@/app/types';
import { isAudioTask } from './task-types';

type WatermarkCreation = Pick<CreationInfo, 'type' | 'has_copyright'> & {
  task?: Pick<TaskInfo, 'type' | 'scene' | 'extra_params'>;
};

/**
 * 作品详情页是否必须使用带水印资源（uri），而非无水印资源（nomark_uri）。
 *
 * 海外站详情页一律带水印，因此恒为 true —— 注意仅限详情页，
 * 做同款预览等场景仍走 getResourceUrl 取 nomark_uri。
 */
export const shouldUseWatermarkedResource = ({
  creation,
  isFree,
}: {
  creation?: WatermarkCreation | null;
  isFree?: boolean;
}): boolean => {
  if (!creation) return false;
  if (SITE === 'china') return !!isFree;
  return true;
};

/**
 * 音频作品是否需要水印。
 * 海外站的水印已烧入封面图（见 constants/audio/audio-images.ts），前端不再叠加。
 * 国内站需展示文字水印标签，并在下载时拼接水印音频。
 */
export const shouldShowAudioWatermark = (taskType?: TaskInfo['type']): boolean => {
  return SITE === 'china' && isAudioTask(taskType);
};

export const getVoiceCloneWatermarkText = (): string => {
  return SITE === 'china' ? 'Vidu AI生成' : 'Vidu AI';
};
